import { useEffect, useState } from "react";
import axios from "axios";
import { History } from "lucide-react";
import { getSessionToken } from "@/utils/auth";

const API = `${window.APP_CONFIG?.BACKEND_URL || process.env.REACT_APP_BACKEND_URL}/api`;

const describe = (e) => {
  switch (e.type) {
    case "tech_cancel_sms_sent": return `Cancellation text sent to ${e.tech} (${e.role}, …${e.to})`;
    case "tech_cancel_sms_skipped": return `Cancellation text not sent to ${e.tech || "tech"}: ${e.reason}`;
    case "tech_cancel_sms_failed": return `Cancellation text to ${e.tech} (${e.role}) failed: ${e.reason}`;
    case "tech_reassigned": return `Tech changed: ${e.from || "none"} → ${e.to || "none"} (customer not notified)`;
    case "status_changed": return `Status: ${e.from || "—"} → ${e.to}`;
    default: return e.type;
  }
};

export function JobTimeline({ jobId }) {
  const [items, setItems] = useState([]);

  useEffect(() => {
    axios.get(`${API}/jobs/${jobId}`, { headers: { Authorization: `Bearer ${getSessionToken()}` } })
      .then((r) => setItems([...(r.data.timeline || [])].reverse()))
      .catch(() => setItems([]));
  }, [jobId]);

  if (!items.length) return null;
  return (
    <div className="border-t border-zinc-200 pt-3" data-testid="job-timeline">
      <p className="flex items-center gap-1.5 text-xs font-semibold text-zinc-500 uppercase tracking-wide mb-2">
        <History className="w-3.5 h-3.5" /> Timeline
      </p>
      <ul className="space-y-1.5 max-h-48 overflow-y-auto">
        {items.map((e) => (
          <li key={e.id} className="text-xs text-zinc-700" data-testid={`job-timeline-item-${e.type}`}>
            <span className="text-zinc-400 mr-1.5">{new Date(e.at).toLocaleString([], { month: "short", day: "numeric", hour: "numeric", minute: "2-digit" })}</span>
            {describe(e)}
            {e.by && <span className="text-zinc-400"> · {e.by}</span>}
          </li>
        ))}
      </ul>
    </div>
  );
}
